import { useEffect, useState } from 'react';
import { getHeaderOffset } from './useScrollContext';
import { useScroll } from './useScrollContext';

export default function useScrollSpy(sectionIds, offset) {
  const { lenis } = useScroll();
  const [activeId, setActiveId] = useState(sectionIds[0] || '');

  useEffect(() => {
    const scrollOffset = offset ?? getHeaderOffset();

    const onScroll = () => {
      const viewportRef = Math.max(scrollOffset, window.innerHeight * 0.45);
      let current = sectionIds[0];
      let closestId = sectionIds[0];
      let closestDistance = Number.POSITIVE_INFINITY;

      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (!el) continue;

        const rect = el.getBoundingClientRect();
        const top = rect.top;
        const bottom = rect.bottom;

        if (top <= viewportRef && bottom > viewportRef) {
          current = id;
          break;
        }

        if (top <= scrollOffset) {
          current = id;
        }

        const distance = Math.abs(top - viewportRef);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestId = id;
        }
      }

      setActiveId(current || closestId);
    };

    onScroll();

    if (lenis) {
      lenis.on('scroll', onScroll);
      return () => lenis.off('scroll', onScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [sectionIds, offset, lenis]);

  return activeId;
}
